export default __webpack_public_path__ + "static/media/056-otter.36c9a3f8.svg";